import { Navigate, Outlet } from "react-router-dom";
import { getAccessToken } from '../../utils';
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import TabToTop from '../../components/TabToTap'
import { useLocation } from 'react-router-dom';
import Main from "../main/index";

const RequireAuth = () => {

  document.querySelector("body").classList.remove("page-style1", "bg-style", "error-page");
  document.querySelector("body").classList.add("main-body", "app","sidebar-mini", "light-mode", "ltr");

  const location = useLocation();

  return (
    getAccessToken() ?
      <div>
        <div>
          <Outlet />
        </div>
        { location.pathname === '/profile/detail' && <TabToTop/>}
      </div>
      :
    <Navigate to="/login" replace />
  );
};

export default RequireAuth;